import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Segment, Grid, Loader} from 'semantic-ui-react';
import {noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import SubstituteModal from '../modals/substituteModal';
import SpecialSubstituteModal from '../modals/specialSubstituteModal';

class ReplacementInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderLoader() {
    return (<Loader active inline='centered'>Consultando...</Loader>);
  }

  renderRelatedParts(loading, parts, showDates = false) {
    if (loading) {
      return this.renderLoader();
    }

    return parts.map((part) => (
      <Segment key={part.code}>
        {part.code}
        {this.renderStock(part.stock)}
        {this.renderDate(part.date, showDates)}
      </Segment>
    ));
  }

  renderDate(date, isVisible = false) {
    if (!isVisible) {
      return null;
    }

    return (
      <span className='substitution-date'>
        {moment(date).format(noTimeZoneShortISODate)}
      </span>
    );
  }

  renderStock(stock) {
    const {readOnly} = this.props;

    if (!readOnly && (stock || stock === 0)) {
      return ` (Stock: ${stock})`;
    }

    return null;
  }

  renderComposedSubstitute() {
    const {loadingComposed, composed} = this.props;

    if (loadingComposed) {
      return this.renderLoader();
    }

    return composed.map((part) => {
      const baseText = `${part.code} | Cantidad: ${part.quantity}`;
      const partText = part.isPrincipal ? `${baseText} | Principal` : baseText;
        
      return (<Segment key={part.code}>{partText}{this.renderStock(part.stock)}</Segment>);
    });
  }

  renderRelatedPartsModal(isSubstitute = false) {
    const {readOnly} = this.props;

    if (!readOnly) {
      return (<SubstituteModal isReplacement={isSubstitute} />);
    }

    return null;
  }

  renderSpecialSubstituteModal() {
    const {readOnly, composed} = this.props;

    if (!readOnly) {
      return (<SpecialSubstituteModal current={composed} />);
    }

    return null;
  }

  render() {
    const {loadingEquivalences, loadingSubstitutes, equivalences, substitutes, previous} = this.props;

    return (
      <Segment secondary className='part-replacement-section'>
        <Grid>
          <Grid.Row columns='4'>
            <Grid.Column>
              <label>
                <strong>Repuestos Compatibles:</strong>
                {this.renderRelatedPartsModal()}
              </label>
              <Segment.Group>
                {this.renderRelatedParts(loadingEquivalences, equivalences)}
              </Segment.Group>
            </Grid.Column>
            <Grid.Column>
              <label><strong>Código Anterior:</strong></label>
              <Segment.Group>
                {this.renderRelatedParts(loadingSubstitutes, previous, true)}
              </Segment.Group>
            </Grid.Column>
            <Grid.Column>
              <label>
                <strong>Código Sustituto:</strong>
                {this.renderRelatedPartsModal(true)}
              </label>
              <Segment.Group>
                {this.renderRelatedParts(loadingSubstitutes, substitutes, true)}
              </Segment.Group>
            </Grid.Column>
            <Grid.Column>
              <label>
                <strong>Despiece:</strong>
                {this.renderSpecialSubstituteModal()}
              </label>
              <Segment.Group>
                {this.renderComposedSubstitute()}
              </Segment.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingEquivalences': state.partsMaster.loadingEquivalences,
    'loadingSubstitutes': state.partsMaster.loadingSubstitutes,
    'loadingComposed': state.partsMaster.loadingComposed,
    'equivalences': state.partsMaster.equivalences,
    'previous': state.partsMaster.previous,
    'substitutes': state.partsMaster.substitutes,
    'composed': state.partsMaster.composed,
  };
};

export default connect(mapStateToProps)(ReplacementInfo);
